// Generated by GPT-4o
import React, { useState, useRef } from "react";
import {
    Box,
    Chip,
    TextField,
} from "@mui/material";

export default function ChipTextField(props) {
    const { chips, setChips } = props
    const [inputValue, setInputValue] = useState("");
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [targetIndex, setTargetIndex] = useState(null);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    // Handles adding a chip on Enter or Comma
    const handleKeyDown = (e) => {
        if (e.key === 'Backspace' && inputValue === "") {
            // Remove the last chip if Backspace is pressed and the input is empty
            setChips(chips.slice(0, -1));
        }
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            const trimmedValue = inputValue.trim();

            if (trimmedValue && !chips.includes(trimmedValue)) {
                setChips([...chips, trimmedValue]);
            }
            setInputValue("");
        }
    };

    // Handles removing a chip
    const handleDelete = (chipToDelete) => {
        setChips(chips.filter((chip) => chip !== chipToDelete));
    };

    // Handles drag start
    const handleDragStart = (index) => {
        setDraggedIndex(index);
    };

    // Handles drag over (prevents default behavior to allow dropping)
    const handleDragOver = (e, index) => {
        e.preventDefault();
        setTargetIndex(index);
    };

    // Handles drop event
    const handleDrop = (index) => {
        if (draggedIndex === null) return;

        let updatedChips = [...chips];
        const draggedChip = updatedChips.splice(draggedIndex, 1)[0]; // Remove dragged item
        updatedChips.splice(index, 0, draggedChip); // Insert at target index

        setChips(updatedChips);
        setDraggedIndex(null);
        setTargetIndex(null);
    };


    const handlePaste = (event) => {
        // Prevent the default paste behavior
        event.preventDefault();
    
        // Get the pasted text and split it by commas
        const pastedText = event.clipboardData.getData('text');
        const newChips = pastedText
          .split(',')
          .map(chip => chip.trim())  // Trim any leading/trailing spaces
          .filter(chip => chip !== '' && !chips.includes(chip));  // Remove empty strings
    
        // Add the new chips to the existing list
        setChips([...chips, ...newChips]);
      };

    return (
        <React.Fragment>
            {chips.map((chip, index) => (
                <Box
                    key={chip}
                    sx={{
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    {/* Drop Indicator - Shows when dragging over */}
                    {targetIndex === index && (
                        <Box
                            sx={{
                                width: "2px",
                                height: "30px",
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                borderRadius: "2px",
                                marginRight: "4px",
                            }}
                        />
                    )}
                    <Chip
                        label={chip}
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={(event) => handleDragOver(event, index)}
                        onDrop={() => handleDrop(index)}
                        onDelete={() => handleDelete(chip)}
                        sx={{
                            cursor: "grab",
                            color: "rgb(255, 255, 255)",
                            border: "1px solid rgba(92, 92, 92, 1)",
                            "& .MuiChip-deleteIcon": {
                                color: 'rgba(92, 92, 92, 1)'
                            },
                            '&:hover': {
                                border: "1px solid rgba(255, 255, 255, 1)",
                                "& .MuiChip-deleteIcon": {
                                    color: 'rgba(222, 155, 145, 1)'
                                },
                            },
                        }}
                    />
                </Box>
            ))}
            <TextField
                variant="outlined"
                size="small"
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                placeholder="Type and press comma or enter..."
                sx={{
                    minWidth: "200px",
                    backgroundColor: "transparent",
                    color: "rgb(255, 255, 255)",
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: "rgb(125, 125, 125)",
                        },
                        "&:hover fieldset": {
                            borderColor: "rgb(255, 255, 255)",
                        },
                        "&.Mui-focused fieldset": {
                            borderWidth: '1px',
                            borderColor: "rgb(125, 125, 125)",
                        },
                    },
                    "& input": {
                        color: "rgb(255, 255, 255)",
                        backgroundColor: 'transparent',
                        border: "none",
                        outline: "none",
                        padding: "2px 5px",
                    },
                    "& .MuiInputBase-input::placeholder": {
                        fontSize: "12px",  // Change this to reduce the placeholder size
                        color: "#888",  // Optional: Change placeholder text color
                    }
                }}
            />
        </React.Fragment>
    );
};
